<form [formGroup]="registerForm" enctype="multipart/form-data" (ngSubmit)="onSubmit()">
  <h1 mat-dialog-title>テナント{{ scope.isEdit ? '更新' : '登録'}}</h1>
  <div mat-dialog-content #contentBody>
    <div class="row mb-10" *ngIf="scope.message">
      <div class="col-md-12">
        <span class="error small">{{ scope.message }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="tenant-cd full-width">
          <input matInput placeholder="テナントコード" formControlName="tenantCd">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput placeholder="テナント名"  formControlName="tenantName">
          <mat-icon matSuffix>business</mat-icon>
          <mat-error *ngIf="f.controls.tenantName.errors && f.controls.tenantName.errors.required">
            テナント名は必須です
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput placeholder="xx-xxxx-xxxx" formControlName="tel">
          <mat-icon matSuffix>local_phone</mat-icon>
          <mat-error *ngIf="f.controls.tel.errors && f.controls.tel.errors.required">
            電話番号は必須です
          </mat-error>  
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput placeholder="住所" formControlName="address">
          <mat-icon matSuffix>location_city</mat-icon>
          <mat-error *ngIf="f.controls.address.errors && f.controls.address.errors.required">
            住所は必須です
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="small">管理者{{ scope.isEdit ? '更新' : '登録'}}</div>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput placeholder="e mail" formControlName="mainEmail">
          <mat-error *ngIf="f.controls.mainEmail.errors && f.controls.mainEmail.errors.required">
              emailは必須です
          </mat-error>
          <mat-icon matSuffix>email</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="!scope.isEdit">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput placeholder="password"  formControlName="password">
          <mat-icon matSuffix>vpn_key</mat-icon>
          <mat-error *ngIf="f.controls.password.errors && f.controls.password.errors.required">
            passwordは必須です
          </mat-error>
        </mat-form-field>
      </div>
    </div>    
    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width">
          <input matInput placeholder="テナント管理者 (氏)" formControlName="mainFamilyName">
          <mat-error *ngIf="f.controls.mainFamilyName.errors && f.controls.mainFamilyName.errors.required">
              管理者名は必須です
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width">
          <input matInput placeholder="テナント管理者 (名)" formControlName="mainFirstName">
          <mat-error *ngIf="f.controls.mainFirstName.errors && f.controls.mainFirstName.errors.required">
            管理者名は必須です
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput placeholder="役職" formControlName="mainPosition">
        </mat-form-field>
      </div>
    </div> 

    <!-- <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <mat-select placeholder="管理フラグ" [(value)]="selectedAdminFlg">
            <mat-option *ngFor="let adminFlgOption of this.tenant.adminFlgOptions" [(value)]="adminFlgOption.value">
              {{adminFlgOption.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->
    <!-- <div class="row">
      <div class="col-md-6">
        <input hidden="false" id="corpIcon" type="file" ng2FileSelect [uploader]="uploader" (change)="uploadSelect($event)" />
        <label for="corpIcon" #file></label>
        <button mat-stroked-button type="button" (click)="file.click()">
          アイコンの設定
        </button>
      </div>
      <div class="col-md-6">
        <img [src]="thumbnailSrc" *ngIf="!!thumbnailSrc" class="thumbnail">
      </div>
    </div> -->
  </div>
  <div mat-dialog-actions class="text-right">
    <button mat-stroked-button [mat-dialog-close]="" >close</button>
    <button *ngIf="!scope.isEdit" mat-stroked-button cdkFocusInitial color="primary" type="submit">登録</button>    
    <button *ngIf="scope.isEdit" mat-stroked-button cdkFocusInitial color="primary" type="submit">更新</button>
  </div>
</form>
